import { useState, useCallback } from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import api from "api/api";
import { useDispatch, useSelector } from "react-redux";
import { showNotification } from "store/features/notificationSlice";
import ProductUsageDialog from "components/common/analysisModule/ProductUsageDialog";

function ProductUsage() {
    const dispatch = useDispatch();
    const selectedStudy = useSelector((state) => state.studyDataStore.selectedStudies) || [];

    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [productUsageData, setProductUsageData] = useState([]);

    // Fetches product usage data from the API and opens the dialog.
    const handleOpenProductUsage = async () => {
        setIsLoading(true);
        const selectedStudyIds = selectedStudy.map((datum) => datum.id).join(",");
        const url = process.env.REACT_APP_SERVER_PATH + `/product-usages/all/?core_data_model_ids=${selectedStudyIds}`;

        try {
            await api
                .get(url)
                .then((res) => {
                    const data = res.data;
                    setProductUsageData(data || []);
                    setIsOpen(true);
                })
                .catch((error) => {
                    handleError("error", error);
                });
        } catch (error) {
            handleError("error", error);
        } finally {
            setIsLoading(false);
        }
    };
    const handleClose = () => setIsOpen(false);

    // Handle error function
    const handleError = useCallback(
        (type, error) => {
            dispatch(showNotification({ severity: type, data: error }));
        },
        [dispatch]
    );

    return (
        <>
            <Button
                size="small"
                variant="contained"
                onClick={handleOpenProductUsage}
                disabled={isLoading}
                style={{ fontSize: 12, minWidth: "128px", marginRight: "20px" }}
                startIcon={
                    isLoading ? (
                        <CircularProgress
                            size={20}
                            color="inherit"
                        />
                    ) : null
                }
            >
                {isLoading ? "Loading..." : "Product Usage"}
            </Button>

            {/* Render dialog here; it handles update internally now */}
            <ProductUsageDialog
                open={isOpen}
                onClose={handleClose}
                initialData={productUsageData}
            />
        </>
    );
}

export default ProductUsage;
